import React, { Component } from 'react';
import Section from './Section.js'
import { FormattedHTMLMessage } from 'react-intl';
import SaveStepButton from './SaveStepButton';

class BasicTemplateForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fields: {},
            sizeContent: this.props.sizeContent ? this.props.sizeContent : ''
        };
    }

    render() {

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)} />
                        {this.props.formattedMessage &&  this.props.formattedDescription && <FormattedHTMLMessage id={this.props.formattedMessage} description={this.props.formattedDescription} />}
                        <div className="show-desktop">
                            <SaveStepButton />
                        </div>
                    </div>
                    <div className={`pd-content-right text-center col-sm-12 col-md-7 col-lg-7 ${this.state.sizeContent}`}>
                        {this.props.children}
                        <div className="show-mobile">
                            <SaveStepButton />
                        </div>
                    </div>
                </div>
            </Section>
        );
    }

}
BasicTemplateForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

export default BasicTemplateForm;



/** WEBPACK FOOTER **
 ** ./src/components/BasicTemplateForm.js
 **/